<swiper-container #swiperContainer [id]="swiperId" [navigation]="navigation" init="false"
                  pagination="true">
  <ng-content></ng-content>
</swiper-container>
@if (showStatus) {
  <span aria-live="polite" class="swiper-status">
    <span class="swiper-status__current">{{ currentSlide }}</span>
    <span aria-hidden="true"> / </span>
    <span>{{ totalSlides }}</span>
  </span>
}
